import React, { useEffect, useRef } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { QRCodeSVG } from "qrcode.react";
import { LogoDefault } from "../../assets/svgs/logos";
import { Close, Copy } from "../../assets/svgs/icons";
import Primary from "../btn/Primary";
import Normal from "../btn/Normal";
interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  type?: "main" | "sub";
  shareUrl?: string;
  onCopy?: () => void;
  copySuccess?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  open,
  onOpenChange,
  type = "main",
  shareUrl,
  onCopy,
  copySuccess = false,
}) => {
  const originalZIndexRef = useRef<string>("");

  useEffect(() => {
    const headerElement = document.querySelector(
      ".common-header-top",
    ) as HTMLElement;

    if (open && headerElement) {
      // 원래 z-index 값 저장
      originalZIndexRef.current = headerElement.style.zIndex || "";
      // 새로운 z-index 설정
      headerElement.style.zIndex = "49";
    } else if (!open && headerElement) {
      // 원래 상태로 복원
      if (originalZIndexRef.current) {
        headerElement.style.zIndex = originalZIndexRef.current;
      } else {
        headerElement.style.zIndex = "";
      }
    }
  }, [open]);

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50" />
        <Dialog.Content className="box-border bg-white flex flex-col gap-10 items-center justify-center max-w-[328px] w-full overflow-hidden pb-4 pt-10 px-4 rounded-[20px] shadow-[0px_6px_12px_-6px_rgba(0,0,0,0.12),0px_8px_24px_-4px_rgba(0,0,0,0.08)] fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50">
          <Dialog.Close asChild>
            <button
              className="absolute right-0 top-0 p-3 w-12 h-12 flex items-center justify-center"
              aria-label="Close"
            >
              <Close className="w-6 h-6" style={{ fill: "#B2B2B2" }} />
            </button>
          </Dialog.Close>
          {type === "main" ? (
            <>
              <div className="flex flex-col gap-2 items-center w-full py-4">
                <LogoDefault className="h-8 w-32" />
              </div>
              <div className="flex flex-col gap-3 items-start w-full">
                <div className="text-[#212121] text-[14px] leading-5 text-center w-full font-medium whitespace-pre-wrap">
                  <p className="mb-0">로그인 후 과학동아AiR를</p>
                  <p>이용해보세요!</p>
                </div>
              </div>
              <div className="flex flex-col gap-4 items-start w-full">
                <Primary style="fill" color="main-gr" className="w-full">
                  로그인
                </Primary>
                <div className="border-t border-[#eeeeee] flex gap-4 items-center justify-between w-full pt-4">
                  <span className="text-[#888888] text-xs">
                    과학동아AiR가 처음이신가요?
                  </span>
                  <Normal
                    style="ghost"
                    className="h-8 py-0 text-xs underline text-[#888888]"
                  >
                    회원가입
                  </Normal>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="flex flex-col gap-4 items-start w-full">
                <div className="flex flex-col gap-3 items-start w-full">
                  <div className="font-bold text-[#212121] text-[16px] leading-[24px] tracking-[-0.32px] text-center w-full">
                    공유하기
                  </div>
                </div>
                <div className="flex flex-col gap-3 items-start w-full">
                  <div className="font-medium text-[#212121] text-[14px] leading-[20px] tracking-[-0.28px] text-center w-full whitespace-pre-wrap">
                    <p className="mb-0">복사하기를 누르면 해당 대화의</p>
                    <p>URL을 복사할 수 있어요!</p>
                  </div>
                </div>
                <div className="flex flex-col gap-[8px] items-start px-[8px] w-full">
                  <div className="box-border border border-[#e0e0e0] rounded-[4px] p-4 w-full flex flex-col gap-4 items-center">
                    <div className="w-[120px] h-[120px]">
                      {shareUrl ? (
                        <QRCodeSVG value={shareUrl} size={120} />
                      ) : (
                        <Copy className="w-12 h-12 text-[#6d2ef2]" />
                      )}
                    </div>
                    <div className="font-normal text-[#666666] text-[12px] leading-[16px] tracking-[-0.24px] w-full break-all">
                      {shareUrl ||
                        "https://air.dongascience.com/share/345652ef-e699-46fe-83bb-bff0387b99e1"}
                    </div>
                  </div>
                  <div className="font-normal text-[#666666] text-[12px] leading-[16px] tracking-[-0.24px] w-full">
                    * '사용자 이름 {">"} 공유 목록'에서 이전 공유 목록을 확인할
                    수 있습니다.
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-4 items-start w-full">
                <Primary
                  style="fill"
                  color="gray"
                  className="!w-full h-[48px] max-h-[48px] min-h-[48px] rounded-[24px]"
                  onClick={onCopy}
                >
                  <span className="font-semibold text-[16px] leading-[24px] tracking-[-0.32px]">
                    {copySuccess ? "복사 완료!" : "복사하기"}
                  </span>
                </Primary>
              </div>
            </>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Modal;
